module.exports = __webpack_public_path__ + "static/media/logo-landtrust-plus-v-2-1.7df7232f.webp";